import clsx from "clsx"
import type { ReactNode } from "react"

import { Icon } from "../Icon"
import { Text } from "../Text"
import styles from "./SliceSelectCard.module.css"

export interface SliceSelectCardProps {
  /**
   * Whether the card should have a fixed height or not. Defaults to `true`.
   */
  fixedHeight?: boolean
  label: string
  variation?: string
  children: ReactNode
  onClick: () => void
  disabled?: boolean
}

export function SliceSelectCard(props: SliceSelectCardProps) {
  const {
    label,
    variation,
    children,
    fixedHeight = true,
    onClick,
    disabled,
  } = props

  const innerContentClassName = clsx(
    styles.innerContent,
    fixedHeight && styles.innerContentFixedHeight,
  )

  const childrenClassName = clsx(
    styles.children,
    fixedHeight && styles.childrenFixedHeight,
  )

  return (
    <button disabled={disabled} className={styles.card} onClick={onClick}>
      <div className={innerContentClassName}>
        <div className={childrenClassName}>{children}</div>
        {!disabled && (
          <div className={styles.plusIcon}>
            <Icon name="add" color="grey1" size="medium" />
          </div>
        )}
      </div>

      <div className={styles.text}>
        <Text variant="smallBold" color="grey11" noWrap>
          {label}
          {variation && (
            <Text variant="smallBold" color="grey12">
              {` > ${variation}`}
            </Text>
          )}
        </Text>
      </div>
    </button>
  )
}
